<script>

export default {
  name: 'LandingPage',

  created() {
    window.location.href = 'https://marketingconstrup.wixsite.com/campanha-constr-up';
  },
};
</script>
